import { useState, useEffect } from 'react';

/**
 * 値の変更を遅延させるカスタムフック
 * @param value - debounceする値
 * @param delay - 遅延時間（ミリ秒）
 * @returns debounceされた値
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // 指定時間後に値を更新
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // クリーンアップ: 次の値が来たら前のタイマーをキャンセル
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
